module.exports = __webpack_public_path__ + "static/media/sn-3000c.3ae907ab.jpg";